import { LoginResponse } from "api/auth";

const getAccessToken = (): string | null => {
  return localStorage.getItem('accessToken');
};

const getRefreshToken = (): string | null => {
  return localStorage.getItem('refreshToken');
}

const storeAccessToken = (response: LoginResponse): void => {
  localStorage.setItem('accessToken', response.data.accessToken);
  localStorage.setItem('refreshToken', response.data.refreshToken);
}

const removeAccessToken = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
}

export { storeAccessToken, removeAccessToken, getAccessToken, getRefreshToken };